import React from "react";

const CircleCheck = ({ animate, background = "default" }) => (
  <span className="circle-check__container">
    <span className={`circle-check ${animate && "animate"} ${background}`}>
      <span className="circle-check__tip" />
      <span className="circle-check__long" />
      <span className="circle-check__placeholder" />
      <span className="circle-check__fix" />
    </span>
  </span>
);

export default CircleCheck;
